import { componentsFromGlobRecord, directivesFromGlobRecord, pagesFromGlobRecord, translationFromGlobRecord } from '@100-m/hauru/src/utils/platformBuilder'
import config from './index.yml'
/**
 * Base app with sync components
 */
export default {
  name: 'cedrus',
  pages: pagesFromGlobRecord(import.meta.glob('./pages/**/*.vue', { eager: true }), './pages'),
  components: componentsFromGlobRecord(import.meta.glob('./components/**/*.vue', { eager: true })),
  directives: directivesFromGlobRecord(import.meta.glob('./directives/**/*.js', { eager: true })),
  translations: translationFromGlobRecord(import.meta.glob('./translations/**/*.yml', { eager: true })),
  config,
}
